function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import React, { useState } from 'react';
import { Box, Card, Heading, Text, Button, Flex } from '@applyboard/crystal-ui';
import useCefNavigation from "../../../CEF/Hooks/useCefNavigation";
import { Routes } from "../../../CEF/Common/Constants";
import { Layout } from "../../../../components/StudentOnboarding/Layout";
import Progress from "../../../../components/Wizards/Progress";
import { SelfDirected } from "../../../../assets/images/SelfDirected";
import { Advisor } from "../../../../assets/images/Advisor";
import { ArrowRightOutlineIcon } from '@applyboard/ui-icons';
import { goToSearchPage } from "../../../../helpers";
import { useCefEventTracker } from "../../../CEF/Hooks/useCefEventTracker";
import { useSearchParams } from "../../../../hooks/useSearchParams";
import { studentOnboarding } from "../../../controller/consts";
var PathwayCard = function PathwayCard(_ref) {
  var title = _ref.title,
    description = _ref.description,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Card, {
    "aria-label": "",
    as: "section",
    emphasis: "outlined",
    height: "fill"
  }, /*#__PURE__*/React.createElement(Card.Clickable, {
    "aria-label": "".concat(title),
    onClick: onClick
  }), /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Flex, {
    justify: "center",
    align: "center",
    direction: "column"
  }, /*#__PURE__*/React.createElement(Box, {
    p: 2,
    hideBelow: "sm"
  }, title === 'Self-directed' ? /*#__PURE__*/React.createElement(SelfDirected, null) : /*#__PURE__*/React.createElement(Advisor, null)), /*#__PURE__*/React.createElement(Heading, {
    level: 2,
    m: 2
  }, title), /*#__PURE__*/React.createElement(Text, {
    contrast: "mid",
    intent: "secondary",
    align: "center"
  }, description))));
};
export var Content = function Content() {
  var navigate = useCefNavigation();
  var params = useSearchParams();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    selfDirected = _useState2[0],
    setSelfDirected = _useState2[1];
  var _useCefEventTracker = useCefEventTracker(),
    trackEvent = _useCefEventTracker.trackEvent;
  if (!params) return null;
  var handleOnClick = function handleOnClick(selfDirected) {
    var eventName = selfDirected ? 'Clicked Continue as Self-Directed' : 'Clicked Continue with Advisor';
    trackEvent({
      event: "".concat(studentOnboarding, " - Applyboost Modal - ").concat(eventName),
      group: studentOnboarding,
      flush: true
    });
    if (selfDirected) {
      goToSearchPage({
        searchParams: params
      });
    } else {
      navigate(Routes.ApplyBoost.AdvisorConfirmationPage);
    }
  };
  var pathwayOptions = [{
    title: 'Self-directed',
    description: "You'll have the freedom to navigate the application process on your own terms, while still receiving support from us at no cost.",
    onClick: function onClick() {
      return setSelfDirected(true);
    }
  }, {
    title: 'Find an advisor',
    description: 'Your third-party advisor will handle your entire application process and will personally assist you for a fee (varies based on services provided).',
    onClick: function onClick() {
      return setSelfDirected(false);
    }
  }];
  var continueButtonText = selfDirected ? 'Continue as Self-Directed' : 'Continue with Advisor';
  return /*#__PURE__*/React.createElement(Layout, {
    noBackButton: true
  }, /*#__PURE__*/React.createElement(Box, {
    px: 8
  }, /*#__PURE__*/React.createElement(Progress, null)), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Flex, {
    direction: "column"
  }, /*#__PURE__*/React.createElement(Flex, {
    justify: "center",
    align: "center",
    direction: "column"
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 1,
    m: 2
  }, "How would you like to continue?"), /*#__PURE__*/React.createElement(Text, {
    contrast: "mid",
    intent: "secondary",
    align: "center"
  }, "Choose your desired pathway for completing your study abroad journey")), /*#__PURE__*/React.createElement(Box, {
    p: 6,
    hideBelow: "sm"
  }, /*#__PURE__*/React.createElement(Flex, {
    gap: 6,
    direction: "row"
  }, pathwayOptions.map(function (option, index) {
    return /*#__PURE__*/React.createElement(Flex.Item, {
      basis: 1,
      grow: 1,
      key: index
    }, /*#__PURE__*/React.createElement(PathwayCard, option));
  }))), /*#__PURE__*/React.createElement(Box, {
    p: 6,
    hideAbove: "sm"
  }, /*#__PURE__*/React.createElement(Flex, {
    gap: 6,
    direction: "column"
  }, pathwayOptions.map(function (option, index) {
    return /*#__PURE__*/React.createElement(Flex.Item, {
      basis: 1,
      grow: 1,
      key: index
    }, /*#__PURE__*/React.createElement(PathwayCard, option));
  }))), /*#__PURE__*/React.createElement(Box, {
    p: 4
  }, /*#__PURE__*/React.createElement(Flex, {
    justify: "center",
    align: "center",
    gap: 4
  }, /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(Button, {
    emphasis: "contained",
    intent: "primary",
    size: "md",
    type: "button",
    width: "hug",
    trailIcon: ArrowRightOutlineIcon,
    onClick: function onClick() {
      return handleOnClick(selfDirected);
    }
  }, continueButtonText)))))));
};